const SHIPPING_HEADING = "where are we shipping";
const CLOSE_SELECTOR = "button, [role='button'], a";
const HEADING_SELECTOR = "h1, h2, h3, [role='heading'], .klaviyo-form-richtext p, .klaviyo-form-richtext span";
const SHIPPING_POPUP_STORAGE_KEY = "kbShippingPopupDismissed";

function getStoredShippingDismissal() {
  try {
    return window.localStorage.getItem(SHIPPING_POPUP_STORAGE_KEY);
  } catch (error) {
    return null;
  }
}

function storeShippingDismissal() {
  try {
    window.localStorage.setItem(SHIPPING_POPUP_STORAGE_KEY, "true");
  } catch (error) {
    // Ignore storage failures so Klaviyo's own click handling can continue.
  }
}

function hasKlaviyoScrollLockingModal() {
  return Boolean(document.querySelector("[data-kl-scroll-locking-modal='true']"));
}

function unlockKlaviyoScroll() {
  if (hasKlaviyoScrollLockingModal()) return;

  const scrollTop = Math.abs(parseInt(document.body?.style.top || "0", 10)) || window.scrollY;

  document.body?.classList.remove("klaviyo-prevent-body-scrolling");
  document.body?.style.removeProperty("overflow");
  document.body?.style.removeProperty("position");
  document.body?.style.removeProperty("top");
  document.body?.style.removeProperty("width");
  document.documentElement?.style.removeProperty("overflow");

  if (scrollTop) {
    window.scrollTo(0, scrollTop);
  }
}

function scheduleKlaviyoScrollUnlock() {
  unlockKlaviyoScroll();
  window.requestAnimationFrame(unlockKlaviyoScroll);
  window.setTimeout(unlockKlaviyoScroll, 50);
  window.setTimeout(unlockKlaviyoScroll, 250);
  window.setTimeout(unlockKlaviyoScroll, 1000);
}

function removePopup(popup) {
  popup.remove();
  scheduleKlaviyoScrollUnlock();
}

function dismissPopup(popup) {
  popup.style.display = "none";
  removePopup(popup);
}

function getHeadingText(element) {
  return element.textContent?.trim().replace(/\s+/g, " ").toLowerCase();
}

function isShippingHeading(element) {
  const text = getHeadingText(element);

  return text === SHIPPING_HEADING || text === `${SHIPPING_HEADING}?`;
}

function normalizeHeading(element) {
  if (element.closest(".klaviyo-form-richtext")) {
    element.dataset.kbShippingHeading = "true";
    element.classList.add("o-heading--3");
    normalizeCloseButton(element);
    return;
  }

  let heading = element;

  if (heading.tagName.toLowerCase() !== "h3") {
    heading = document.createElement("h3");

    [...element.attributes].forEach((attribute) => {
      heading.setAttribute(attribute.name, attribute.value);
    });

    heading.innerHTML = element.innerHTML;
    element.replaceWith(heading);
  }

  heading.dataset.kbShippingHeading = "true";
  heading.classList.add("o-heading--3");
  normalizeCloseButton(heading);
}

function findPopupRoot(heading) {
  return (
    heading.closest("[role='dialog'], [aria-modal='true'], [class*='modal' i], [class*='popup' i], [class*='dialog' i]") ||
    heading.parentElement?.parentElement?.parentElement ||
    heading.parentElement
  );
}

function isCloseControl(element) {
  const label = element.getAttribute("aria-label") || element.getAttribute("title") || "";
  const className = element.getAttribute("class") || "";
  const text = element.textContent?.trim().toLowerCase() || "";

  return (
    /close|dismiss/i.test(label) ||
    /close|dismiss/i.test(className) ||
    text === "x" ||
    text === "×"
  );
}

function normalizeCloseButton(heading) {
  const popup = findPopupRoot(heading);
  if (!popup) return;

  popup.dataset.kbShippingPopup = "true";

  const closeButton = [...popup.querySelectorAll(CLOSE_SELECTOR)].find(isCloseControl);

  if (getStoredShippingDismissal()) {
    dismissPopup(popup);
    return;
  }

  bindShippingPopupDismissal(popup);

  if (!closeButton) return;

  closeButton.dataset.kbShippingClose = "true";
  closeButton.setAttribute("aria-label", closeButton.getAttribute("aria-label") || "Close");
}

function bindShippingPopupDismissal(popup) {
  if (popup.dataset.kbShippingDismissBound === "true") return;

  popup.dataset.kbShippingDismissBound = "true";

  popup.addEventListener("click", (event) => {
    const button = event.target.closest("button, a, [role='button']");
    if (!button) return;

    const isCloseButton = button.matches("[data-kb-shipping-close='true'], .klaviyo-close-form");
    const isShippingOption = button.matches(".klaviyo-form-button");

    if (!isCloseButton && !isShippingOption) return;

    storeShippingDismissal();
  });
}

function normalizeShippingPopupHeadings(root = document) {
  const candidates = new Set();

  if (root.matches?.(HEADING_SELECTOR)) {
    candidates.add(root);
  }

  root.querySelectorAll?.(HEADING_SELECTOR).forEach((element) => {
    candidates.add(element);
  });

  candidates.forEach((element) => {
    if (element.dataset.kbShippingHeading === "true") return;
    if (!isShippingHeading(element)) return;

    normalizeHeading(element);
  });
}

normalizeShippingPopupHeadings();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        normalizeShippingPopupHeadings(node);
      }
    });
  });
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
